export const assets = {
  home_banner: 'assets/images/xploraluxe-luxury-experiences.mp4',
  logo: 'assets/images/xplora_logo.png',
  logo2: 'assets/images/xplora_logo2.png',
  language_icon: 'assets/images/language_icon.svg',
  banner_attachment: 'assets/images/banner_attachment.jpg',
  calender_icon: 'assets/images/calender_icon.svg',
  location_icon: 'assets/images/location_icon.svg',
  search_icon: 'assets/images/search_icon.svg',
  search_icon2: 'assets/images/search_icon2.svg',
  date_icon: 'assets/images/date_icon.svg',
  hotel_icon: 'assets/images/hotel_icon.svg',
  dinning_icon: 'assets/images/dinning_icon.svg',
  car_icon: 'assets/images/car_icon.svg',
  calendar_check_icon: 'assets/images/calendar_check_icon.svg',
  face_happy_icon: 'assets/images/face_happy_icon.svg',
  stars_icon: 'assets/images/stars_icon.svg',
  coins_hand_icon: 'assets/images/coins_hand_icon.svg',
  check_verified_icon: 'assets/images/check_verified_icon.svg',
  instagram_icon: 'assets/images/instagram_icon.svg',
  cart_free: 'assets/images/empty-cart.png',
  dribble_icon: 'assets/images/dribble_icon.svg',
  twitter_icon: 'assets/images/twitter_icon.svg',
  youtube_icon: 'assets/images/youtube_icon.svg',
  facebook_icon: 'assets/images/facebook.svg',
  linkedin_icon: 'assets/images/linkedin.svg',
  google_login_icon: 'assets/images/google_login_icon.svg',
  facebook_login_icon: 'assets/images/facebook_login_icon.svg',
  offer_icon1: 'assets/images/offer_icon1.svg',
  offer_icon2: 'assets/images/offer_icon2.svg',
  offer_icon3: 'assets/images/offer_icon3.svg',
  offer_icon4: 'assets/images/offer_icon4.svg',
  offer_icon5: 'assets/images/offer_icon5.svg',
  offer_icon6: 'assets/images/offer_icon6.svg',
  offer_icon7: 'assets/images/offer_icon7.svg',
  offer_icon8: 'assets/images/offer_icon8.svg',
  offer_icon9: 'assets/images/offer_icon9.svg',
  parachute_icon: 'assets/images/parachute_icon.svg',
  trash_icon: 'assets/images/trash_icon.svg',
  icon1: 'assets/images/icon1.svg',
  icon2: 'assets/images/icon2.svg',
  icon3: 'assets/images/icon3.svg',
  pencil_icon: 'assets/images/pencil_icon.svg',
  tick_icon: 'assets/images/tick_icon.svg',
  user_attachment: 'assets/images/user_attachment.png',
  user_attachment2: 'assets/images/user_attachment2.png',
  user_attachment3: 'assets/images/user_attachment3.jpg',
  user_attachment4: 'assets/images/user_attachment4.png',
  visa_icon: 'assets/images/visa_icon.png',
  card_icon: 'assets/images/card_icon.png',
  success_icon: 'assets/images/success_icon.png',
  inner_banner_bg: 'assets/images/inner_banner_bg.jpg',
  homebanner:'assets/images/homepage banner.png',
  attachment01: 'assets/images/XL-Banner-BRAnew.jpg',
  attachment02: 'assets/images/attachment_02.jpg',
  attachment03: 'assets/images/attachment_03.jpg',
  attachment04: 'assets/images/attachment_04.jpg',
  attachment05: 'assets/images/attachment_05.jpg',
  attachment06: 'assets/images/attachment_06.jpg',
  attachment07: 'assets/images/attachment_07.jpg',
  attachment09: 'assets/images/attachment_09.jpg',
  attachment10: 'assets/images/attachment_10.jpg',
  attachment11: 'assets/images/attachment_11.jpg',
  attachment12: 'assets/images/attachment_12.jpg',
  attachment13: 'assets/images/attachment_13.jpg',
  attachment14: 'assets/images/attachment_14.jpg',
  attachment15: 'assets/images/attachment_15.jpg',
  attachment17: 'assets/images/attachment_17.jpg',
  attachment18: 'assets/images/attachment_18.jpg',
  attachment19: 'assets/images/attachment_19.jpg',
  attachment20: 'assets/images/attachment_20.jpg',
  attachment21: 'assets/images/attachment_21.jpg',
  attachment22: 'assets/images/attachment_22.jpg',
  attachment23: 'assets/images/attachment_23.jpg',
  attachment24: 'assets/images/attachment_24.jpg',
  attachment25: 'assets/images/attachment_25.jpg',
  attachment26: 'assets/images/attachment_26.jpg',
  attachment27: 'assets/images/attachment_27.jpg',
  attachment28: 'assets/images/attachment_28.jpg',
  attachment29: 'assets/images/attachment_29.jpg',
  attachment30: 'assets/images/attachment_30.jpg',
  attachment31: 'assets/images/attachment_31.jpg',
  attachment32: 'assets/images/attachment_32.png',
  offer_attachment1: 'assets/images/offer_attachment1.jpg',
  offer_attachment2: 'assets/images/offer_attachment2.jpg',
  noDataFound: 'assets/images/Nodat-found.png',
  visa: 'assets/images/visa.png',
  googlepay:'assets/images/google.png',
  applepay:'assets/images/applePay.png',
  samsungpay:'assets/images/samsung.png',
  master_icon: 'assets/images/master.png',
  union_icon: 'assets/images/union.png',
  american_icon: 'assets/images/american-express.png',
  elseLogo: 'assets/images/xploralogo1.jpg',
  noreview: 'assets/images/ratigimg.png',
  pickupMarker: 'assets/images/pickup.png',
  dropoffMarker: 'assets/images/dropoff.png',
  cancelledIcon: 'assets/images/cancelled.png',
  declinedIcon: 'assets/images/declined.png',
  HomeSlider1: 'assets/images/slide-home2.png',
  HomeSlider2: 'assets/images/slide-home3.png',
  HomeSlider3: 'assets/images/slide-home4.png',
  HomeSlider4: 'assets/images/slide-home5.png',
  defaultBanner: 'assets/images/placeholder_banner.jpg',
  emailImage: 'assets/images/email_Image.jpeg',
  searchBanner: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930061403_searchBanner.png',
  premiumPlacement: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930787087_PremiumPlacement.webp',
  ourStories: 'assets/images/OurStories.png',
  markettingServices: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930568684_MarketingServices.webp',
  concierge: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930528763_Concierge.webp',
  aboutUs: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930674353_aboutUs.webp',
  whyPartnerWithUs: 'https://xlwahosb.s3.me-central-1.amazonaws.com/Xploraluxe/1738930950630_whyPartnerWithUs.webp',
  dirham_icon:'./assets/images/dirham_icon.png',
  dirham:'./assets/images/dirhamIcon.png'
};
